import { createStore } from 'redux';
import reducer from './reducers/reducer';

export const generateStore = () => createStore(reducer);
const store = generateStore();
export default store;
